import React, { useState } from 'react'

import { StyledLink, StyledSkipLinks } from './SkipLinks.styled'

const SkipLinks = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <StyledSkipLinks
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
      $isVisible={isVisible}
    >
      <StyledLink href="#content" label="Go to content" />
      <StyledLink href="#menu" label="Go to menu" />
      <StyledLink href="#footer" label="Go to footer" />
    </StyledSkipLinks>
  )
}

export default SkipLinks
